import { call, put } from "redux-saga/effects";
import { apiFoco, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListCitiesActions } from "store/ducks/city";

import { ICity } from "interfaces/city";

export function* ListCitiesRequest(action: any) {
  try {
    const { query = {} } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(apiFoco.get, `/cities?${queryString}`);

    const comboOptions = data.map((city: ICity) => ({
      value: city.name,
      label: city.name,
    }));

    yield put(ListCitiesActions.success(comboOptions));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListCitiesActions.failure(errorMessage));
  }
}
